import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Captcha from 'components/Captcha';
import { fetchStatusModal } from 'store/fetchActions/fetchApp';
import { ID_CAPTCHA, USER_ENTERED_CAPTCHA_CODE } from 'utils/consts';

export const ValidarCaptcha = () => {
  const dispatch = useDispatch();
  const modalState = useSelector(state => state.app.modal);

  const { onOk, titleButton } = modalState.props;

  const onSendCaptcha = e => {
    localStorage.setItem(ID_CAPTCHA, e.captchaId);
    localStorage.setItem(USER_ENTERED_CAPTCHA_CODE, e.userEnteredCaptchaCode?.toUpperCase());
    onOk();
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <Captcha
        onSendCaptcha={onSendCaptcha}
        buttonLabel={titleButton}
        onClose={() => dispatch(fetchStatusModal(false, ''))}
      />
    </div>
  );
};

export default ValidarCaptcha;
